module.exports = __webpack_public_path__ + "img/cpa.bb27b510.png";